import { useDispatch, useSelector } from 'react-redux'

import type { AppDispatch, RootState } from './types'

/**
 * Единственный вход в store для bindings (CLAUDE.md §7): голые
 * useSelector/useDispatch запрещены eslint везде, кроме этого файла.
 */
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
